import { render, staticRenderFns } from "./mindsets-list-panel.vue?vue&type=template&id=7fb6c062&"
import script from "./mindsets-list-panel.ts?vue&type=script&lang=ts&"
export * from "./mindsets-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./mindsets-list-panel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports